import { useEffect, useRef, useState } from 'react'

import { DUE_DATE_PRESETS, dueDateFromPreset } from '../lib/dueDatePresets'

import DateTimeMenu from './DateTimeMenu'
import QuickPill from './QuickPill'

// Date + time picker on top, quick presets below. `onChange` receives the new
// due date (or null when cleared); the parent owns the reminder.
//
// The active pill reflects the preset the user just clicked this session, not a
// recomputation against "now" — presets are relative ("1w from today"), so a
// stored absolute date would otherwise drift out of the highlight a day later.
const DueControl = ({ dueDate, onChange }) => {
  const [activeLabel, setActiveLabel] = useState<string | null>(null)
  // The exact value our last preset click produced, so we can tell an external
  // change (custom pick, template prefill, reset) from our own.
  const presetValue = useRef<Date | null>(null)

  useEffect(() => {
    if (dueDate?.valueOf?.() !== presetValue.current?.valueOf?.()) {
      setActiveLabel(null)
    }
  }, [dueDate])

  const applyPreset = (preset) => {
    const value = dueDateFromPreset(preset)
    presetValue.current = value
    setActiveLabel(preset.label)
    onChange(value)
  }

  return (
    <div className="flex flex-col items-end gap-2">
      <DateTimeMenu
        value={dueDate}
        onChange={onChange}
        placeholder="No Due Date"
        minDate={new Date()}
      />
      <div className="flex flex-wrap justify-end gap-1">
        {DUE_DATE_PRESETS.map((preset) => (
          <QuickPill
            key={preset.label}
            active={activeLabel === preset.label}
            onClick={() => applyPreset(preset)}
          >
            {preset.label}
          </QuickPill>
        ))}
        {dueDate && (
          <QuickPill muted onClick={() => onChange(null)}>
            Clear
          </QuickPill>
        )}
      </div>
    </div>
  )
}

export default DueControl
